<template>
  <div class="py-16 sm:py-32 gradient-liquid-angles" id="signup">
    <div class="container">
      <div class="text-center leading-normal text-white mt-10">
        <h2 class="mb-4 mt-10 text-xl sm:text-3xl">Alright, so you're ready to join?</h2>
        <p class="mx-auto mb-8 max-w-md text-md sm:text-lg">
          Tiny Contest is currently invite only. Sign up below and we will be in touch with an invite shortly. Have a question?
          <a
            class="text-white underline"
            href="mailto:contact@contestkit.com"
          >Ask away.</a>
        </p>
        <div class="text-center">
          <div class="w-full max-w-md mx-auto" v-if="success">
            <div
              class="flex items-center bg-green text-white text-sm font-bold px-4 py-3 rounded shadow"
              role="alert"
            >
              <p>Success!.</p>
            </div>
          </div>

          <form ref="form" class="mx-auto max-w-md" data-rewardful @submit.prevent="submit">
            <div class="flex flex-col py-2 shadow-inner">
              <input
                @focus="clearErrors"
                v-model="email"
                :class="{'border-brand-red bg-brand-red-75 text-white': errors.has('email')}"
                class="w-full mr-3 bg-grey-lightest border border-grey-light rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey"
                type="email"
                placeholder="your@email.com"
                aria-label="Email"
                aria-required="true"
              >
              <p
                v-if="errors.has('email')"
                class="text-brand-red italic pt-3 text-left"
              >{{ errors.first('email') }}</p>
            </div>

            <div class="flex justify-end py-2">
              <button
                :disabled="busy"
                class="flex-no-shrink btn btn-primary-solid bg-brand-red border-none"
              >Request an invitation</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Errors from "../utils/Errors";

export default {
  props: ["path"],
  data: () => ({
    email: null,
    busy: false,
    message: null,
    success: false,
    errors: new Errors()
  }),
  mounted() {},
  methods: {
    submit() {
      this.busy = true;
      axios
        .post(this.path, {
          email: this.email,
          referral: this.referral
        })
        .then(response => {
          this.success = true;
          this.email = null;
        })
        .catch(error => {
          const errors = error.response
            ? error.response.data.errors
            : error.data.errors;
          this.errors = new Errors();
          this.errors.record(errors);
        })
        .then(() => {
          this.busy = false;
        });
    },
    clearErrors() {
      this.errors = new Errors();
    }
  },
  computed: {
    referral() {
      return this.$refs.form.elements["referral"]
        ? this.$refs.form.elements["referral"].value
        : null;
    }
  },
  watch: {
    email() {
      if (this.errors.any()) {
        this.clearErrors();
      }
    }
  }
};
</script>
